import { useState } from "react";
import OccupationAreaService from "../../services/OccupationAreaService";
import OccupationSubareaService from "../../services/OccupationSubareaService";

function createSubareaData(response) {

    if (response == null) return null;

    return {
        id: response.id,
        key: response.key,
        name: response.name,
        occupationAreaId: response.occupationAreaId,
    };
}

function createAreaData(response) {

    if (response == null) return null;

    return {
        id: response.id,
        key: response.key,
        name: response.name,
        subareas: (response.subareas ?? []).map((subarea) => createSubareaData(subarea)),
    };
}

const useOccupations = () => {
    const [loading, setLoading] = useState(true);
    const [occupationAreas, setOccupationAreas] = useState([]);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [updateFailure, setUpdateFailure] = useState(false);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUpdateSuccess(false);
        setUpdateFailure(false);
    };

    // region service calls

    const getOccupations = async () => {
        const response = await OccupationAreaService.getOccupationAreas();
        setOccupationAreas((response ?? []).map((area) => createAreaData(area)));
        setLoading(false);
    };

    const saveOccupationArea = async (area) => {
        const response = area.id
            ? await OccupationAreaService.updateOccupationArea(area.id, area)
            : await OccupationAreaService.createOccupationArea(area);
        if (response) {
            setUpdateSuccess(true);
            await getOccupations();
        } else {
            setUpdateFailure(true);
        }
        return response;
    };

    const deleteOccupationArea = async (area) => {
        const response = await OccupationAreaService.deleteOccupationArea(area.id);
        if (response) {
            setUpdateSuccess(true);
            await getOccupations();
        } else {
            setUpdateFailure(true);
        }
    };

    const saveOccupationSubarea = async (subarea) => {
        const response = subarea.id
            ? await OccupationSubareaService.updateOccupationSubarea(subarea.id, subarea)
            : await OccupationSubareaService.createOccupationSubarea(subarea);
        if (response) {
            setUpdateSuccess(true);
            await getOccupations();
        } else {
            setUpdateFailure(true);
        }
        return response;
    };

    const deleteOccupationSubarea = async (subarea) => {
        const response = await OccupationSubareaService.deleteOccupationSubarea(subarea.id);
        if (response) {
            setUpdateSuccess(true);
            await getOccupations();
        } else {
            setUpdateFailure(true);
        }
    };

    // end region

    return {
        loading,
        occupationAreas,
        getOccupations,
        saveOccupationArea,
        deleteOccupationArea,
        saveOccupationSubarea,
        deleteOccupationSubarea,
        updateSuccess,
        updateFailure,
        handleClose,
    }
};

export default useOccupations;
